import React from 'react';
import Styles from './StoreNotFound.css';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { useScroll } from '../../../../utils/useLayout';

function StoreNotFoundPartial() {
  const { scrollToTop } = useScroll();
  const { setSimulationStep, setSimulationType } = useSimuladorEnergiaSolarState();
  const handleRegenerate = async (isFind = false) => {
    setSimulationStep(SIMULATION_STEPS.FORM_BASIC_INFO);
    if (isFind) {
      setSimulationType('new');
    }
    scrollToTop();
  };

  return (
    <>
      <div id="store-not-found" className="store-not-found">
        <ContainerHome24>
          <img
            className="error-icon"
            src="assets/simulador-energia-solar/jornada/ic-error.svg"
            alt=""
          />
          <h6 className="title">Loja não parceira</h6>
          <p className="description">
            A loja do seu orçamento não é um parceiro cadastrado Santander. Tente novamente
            encontrar a loja ou encontre um parceiro Santander mais próximo e continue sua
            simulação.
          </p>

          <Button
            variant="white"
            onClick={(ev) => {
              ev.preventDefault();

              handleRegenerate();
            }}
          >
            Tentar novamente
          </Button>
          <Button
            variant="red"
            onClick={(ev) => {
              ev.preventDefault();

              handleRegenerate(true);
            }}
          >
            Encontrar parceiro
          </Button>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default StoreNotFoundPartial;
